import SummaryDetailTabComponent from './SummaryDetailTab';

const SummaryDetailTab = SummaryDetailTabComponent;

export default SummaryDetailTab;
